import React, { useContext, useMemo, useState } from "react";
import { Box, HStack, Heading, Text, VStack } from "native-base";
import { Helmet } from "react-helmet-async";
import { useNavigate, useSearchParams } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import es from "react-phone-number-input/locale/es.json";
import styles from "./styles.module.css";
import colors from "../../constants/colors";
import API, { source } from "../../api";
import { StatusContext } from "../../contexts";
import routes from "../../routes";

function SignUpPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = useContext(StatusContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const action = useMemo(() => searchParams.get("action"), [searchParams]);
  const url = useMemo(() => searchParams.get("url"), [searchParams]);

  const onRegister = async () => {
    setIsLoading(true);
    try {
      if (password !== confirmPassword) {
        throw new Error("Contraseñas no coinciden");
      }
      const {
        data: { user },
      } = await API().post("/auth/local/register", {
        username: email,
        email,
        password,
        firstName,
        lastName,
        phone,
        source,
      });
      status.updateSuccessMessage(
        "¡Gracias por registrarte! Por favor, verifica tu cuenta a través del enlace que te enviamos por correo electrónico. ¡Bienvenido!",
      );
      if (action === "quotation" && url && url.match(/^.+\/(\d+)\/.+$/)) {
        const quotationId = url.match(/^.+\/(\d+)\/.+$/)[1];
        try {
          await API().put(`/quotations/${quotationId}`, {
            data: { user: user.id },
          });
        } catch (error) {
          status.updateErrorMessage(error);
        }
        navigate(url);
      } else {
        navigate(routes.home);
      }
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  };

  return (
    <VStack paddingTop={50} alignItems="center">
      <Helmet>
        <title>Registro</title>
      </Helmet>
      <Heading color={colors.secondary} fontSize="2xl" textAlign="center">
        Regístrate
      </Heading>
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          onRegister();
        }}
        autoComplete="off">
        <VStack
          backgroundColor={colors.white}
          paddingX={10}
          paddingTop={5}
          paddingBottom={10}
          borderRadius={5}
          space={5}
          marginTop={7}>
          <HStack marginTop={5} space={5}>
            <label className={styles.input}>
              <Text>Nombre</Text>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
            <label className={styles.input}>
              <Text>Apellido</Text>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
          </HStack>
          <HStack space={5}>
            <label className={styles.input}>
              <Text>Número de teléfono</Text>
              <PhoneInput
                labels={es}
                defaultCountry="MX"
                disabled={isLoading}
                value={phone}
                onChange={setPhone}
                required
              />
            </label>
            <label className={styles.input}>
              <Text>Correo electrónico</Text>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
                autoComplete="new-password"
              />
            </label>
          </HStack>
          <HStack space={5}>
            <label className={styles.input}>
              <Text>Contraseña</Text>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
                autoComplete="new-password"
              />
            </label>
            <label className={styles.input}>
              <Text>Confirmar contraseña</Text>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={isLoading}
                autoComplete="new-password"
              />
            </label>
          </HStack>
        </VStack>
        <button disabled={isLoading}>
          <Box
            backgroundColor={colors.primary}
            paddingX={20}
            paddingY={2}
            borderRadius="full">
            <Text color={colors.white}>Continuar</Text>
          </Box>
        </button>
      </form>
    </VStack>
  );
}

export default SignUpPage;
